import { usePartnerConsentCreateUserConsentQuery } from '../../data-access';

export const useCreateUserConsents = () => {
	return usePartnerConsentCreateUserConsentQuery();
};
